import React from 'react'
import PropTypes from 'prop-types'
import { propOr } from 'ramda'
import { useDispatch } from 'react-redux'
import { useSelector, useMakeSelector } from 'hooks/redux'
import { Button } from 'components/patterns/index'
import { setSelectedId } from 'actions/navigator'
import {
  getSelectedId,
  makeComponentMetaSelector,
  getHideBreadcrumb,
} from 'selectors/navigator'
import styled from '@emotion/styled'
import { StyledNavigator } from './Navigator.style'
import withStyle from './ReduxNavigator.style'

const ReduxNavigator = ({ render, className, dataTestId }) => {
  const dispatch = useDispatch()
  const selectedId = useSelector(getSelectedId)
  const hideBreadcrumb = useSelector(getHideBreadcrumb)

  const componentMeta = useMakeSelector(makeComponentMetaSelector, {
    id: selectedId,
  })
  const { parentId, ...rest } = componentMeta

  const parentComponentMeta = useMakeSelector(makeComponentMetaSelector, {
    id: parentId,
  })

  const parentDescription = propOr(null, 'description')(parentComponentMeta)

  const breadcrumbProps = {
    ...(parentDescription && {
      className: 'link',
      onClick: () => dispatch(setSelectedId(parentId)),
      link: true,
    }),
  }

  return (
    <div className={className} data-testid={dataTestId}>
      {!hideBreadcrumb && parentDescription && (
        <StyledNavigator>
          <TruncatedButton {...breadcrumbProps}>
            {parentDescription}
          </TruncatedButton>
        </StyledNavigator>
      )}
      {render({
        id: selectedId,
        key: selectedId,
        parentId,
        ...rest,
      })}
    </div>
  )
}

ReduxNavigator.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  render: PropTypes.func,
}

export default withStyle(ReduxNavigator)

export const TruncatedButton = styled(Button)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 50%;
  display: inline-block;
`
